var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidUkRegulationsHnwInvestor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18C20.6421 18 24 14.6421 24 10.5C24 6.35786 20.6421 3 16.5 3C12.3579 3 9 6.35786 9 10.5C9 14.6421 12.3579 18 16.5 18Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3872 33C29.3872 27.195 23.6122 22.5 16.5022 22.5C9.39218 22.5 3.61719 27.195 3.61719 33",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2047 27H22.7953C22.356 27 22 27.3241 22 27.7239V29.2761C22 29.6759 22.356 30 22.7953 30H33.2047C33.644 30 34 29.6759 34 29.2761V27.7239C34 27.3241 33.644 27 33.2047 27Z",
    fill: "white",
    stroke: "#CACACA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2047 24H22.7953C22.356 24 22 24.3241 22 24.7239V26.2761C22 26.6759 22.356 27 22.7953 27H33.2047C33.644 27 34 26.6759 34 26.2761V24.7239C34 24.3241 33.644 24 33.2047 24Z",
    fill: "white",
    stroke: "#CACACA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2047 30H22.7953C22.356 30 22 30.3241 22 30.7239V32.2761C22 32.6759 22.356 33 22.7953 33H33.2047C33.644 33 34 32.6759 34 32.2761V30.7239C34 30.3241 33.644 30 33.2047 30Z",
    fill: "white",
    stroke: "#CACACA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidUkRegulationsHnwInvestor);
export default __webpack_public_path__ + "static/media/bfid-uk-regulations-hnw-investor.e2a042eb8afdab700ab98588dc10a671.svg";
export { ForwardRef as ReactComponent };